import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18nHelper from "@/core/services/i18n.service";
import DepositReservationModel from "@/modules/invoices/models/DepositReservation.model";
import {Formatter} from "@/core/services/formatter.service";

export default class DepositInvoiceModel extends BaseModel {
  uuid = null;
  customer_uuid = null;
  deposit_amount = null;
  deposit_reservations = [];
  preferred_language_code = null;
  invoice_billing_address = null;
  invoice_shipping_address = null;
  exclude_from_auto_payments = null;

  static TRANSLATABLE_FIELDS = [];
  date = Formatter.getCurrentDate();
  rules = {
    customer_uuid: 'required',
    deposit_amount: 'required',
    preferred_language_code: 'required',
  };

  attributeLabels = {
    customer_uuid: i18n.t('Customer'),
    deposit_amount: i18n.t('Amount'),
    is_exported: i18n.t('Export Items'),
    is_tax_applied: i18n.t('Apply VAT'),
    is_registered_business: i18n.t('Exported outside EU'),
    preferred_language_code: i18n.t('Preferred Language'),
    date: i18n.t('Date'),
    exclude_from_auto_payments: i18n.t('Exclude from Auto-Payments'),
  };

  attributeHints = {
    preferred_language_code: i18n.t('Invoice template will be created according to the selected language'),
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.preferred_language_code = this.preferred_language_code || i18nHelper.getMasterLanguage().key;
    if (!this.deposit_reservations.length) {
      this.deposit_reservations.push(new DepositReservationModel({amount: this.deposit_amount || 0}));
    }
  }
}
